export enum TiposMensajesEnum {
    Entrante = 1,
    Saliente = 2    
}
